import React from 'react'

import ChatBubble from '@components/chat-bubble/chat-bubble.component'
import ReferenceBubble from '@components/reference-bubble/reference-bubble.component'


const ChatBubbleFilter = ({ message, children, ...props }) => {
  const { type } = message

  switch (type) {
  case 'reference':
    return (
      <ReferenceBubble {...props}>
        {children}
      </ReferenceBubble>)
  default:
    return (
      <ChatBubble {...props}>
        {children}
      </ChatBubble>
    )
  }
}

export default ChatBubbleFilter
